import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import NotificationDropdownList from "./components/notification-drop-down-list.vue";
import { watch, onMounted, computed } from "vue";
import { useNotifications } from "./composition/use-notifications";
import { useChartGroupsStore } from "@/features/chart-groups/store/chart-groups-store";


export default /*#__PURE__*/_defineComponent({
  __name: 'user-notifications',
  setup(__props) {

const {
  store,
  hasUnreadNotifications,
  isLoading,
  currentPage,
  totalPages,
  handleScroll,
  handleNotificationClick,
} = useNotifications();

const chartGroupsStore = useChartGroupsStore();
const chartGroupId = computed(() => chartGroupsStore.getSelectedChartGroupId);

onMounted(() => {
  initializeNotifications();
});

const initializeNotifications = () => {
  const currentChartGroupId = store.getChartGroupId;
  if (currentChartGroupId !== null) {
    store.fetchNotifications(currentChartGroupId);
  }
};

watch(chartGroupId, (newChartGroupId) => {
  console.log("Chart group ID changed:", newChartGroupId);
  if (newChartGroupId !== null) {
    store.fetchNotifications(newChartGroupId);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(NotificationDropdownList, {
      notifications: _unref(store).notifications,
      hasUnreadNotifications: _unref(hasUnreadNotifications),
      isLoading: _unref(isLoading),
      handleNotificationClick: _unref(handleNotificationClick),
      currentPage: _unref(currentPage),
      totalPages: _unref(totalPages),
      handleScroll: _unref(handleScroll)
    }, null, 8, ["notifications", "hasUnreadNotifications", "isLoading", "handleNotificationClick", "currentPage", "totalPages", "handleScroll"])
  ]))
}
}

})